import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "datatable-relative",
  relative: ""
}
const _hoisted_2 = { class: "datatable" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "left row-vcenter" }
const _hoisted_5 = { class: "right row-vcenter" }
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_DataTable = _resolveComponent("DataTable", true)
  const _directive_window_resize = _resolveDirective("window-resize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header-left", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "header-right", {}, undefined, true)
        ])
      ]),
      ($options.empty)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "empty",
            disabled: $props.loading
          }, [
            _renderSlot(_ctx.$slots, "empty", {}, undefined, true)
          ], 8 /* PROPS */, _hoisted_6))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            value: $props.items,
            disabled: $props.loading,
            rows: _ctx.rows,
            "always-show-paginator": false,
            lazy: $props.lazy,
            "total-records": $props.total,
            loading: $props.loading,
            "sort-order": $props.sortOrder,
            "sort-field": $props.sortField,
            first: _ctx.first,
            relative: "",
            paginator: "",
            "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
            "current-page-report-template": "Page {currentPage} of {totalPages}",
            pt: {
                   root: 'root',
                   table: 'table shared-table',
                   thead: 'thead',
                   tbody: 'tbody',
                   headerRow: 'headerRow',
                   headerCell: 'headerCell',
                   bodyRow: 'bodyRow',
                   sort: 'sort',
                   pcpaginator: {
                     root: 'paginator-root',
                     content: 'content',
                     pages: 'pages',
                     page: 'page',
                     current: 'current',
                     prev: ['prev', 'pointer'],
                     next: ['next', 'pointer'],
                     first: ['first', 'pointer'],
                     last: ['last', 'pointer']
                   },
                   column: {
                     headerCell: 'headerCell',
                     bodyCell: 'bodyCell',
                     columnHeaderContent: 'columnHeaderContent',
                     sort: 'sort',
                   },
                 },
            onPage: _cache[0] || (_cache[0] = $event => (_ctx.$emit('page', $event))),
            onSort: _cache[1] || (_cache[1] = $event => (_ctx.$emit('sort', $event))),
            onRowDblclick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('row-dblclick', $event)))
          }, {
            loading: _withCtx(() => [
              _createCommentVNode(" NEED TO PREVENT DEFAULT LOADING ")
            ]),
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["value", "disabled", "rows", "lazy", "total-records", "loading", "sort-order", "sort-field", "first"]))
    ])), [
      [_directive_window_resize, $options.configureTable, "200"]
    ])
  ]))
}